export const quizimportcategoryData = [
  { key: "esports", text: "Esports", value: "esports" },
  { key: "esl", text: "ESL", value: "esl" },
  { key: "gaming", text: "Gaming", value: "gaming" },
];
